import React from 'react';

export default () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="20" height="20" rx="10" fill="white" />
    <path d="M10.886 11.3855V5.98555H9.11416V11.3855H10.886ZM10.886 15.0137V13.1996H9.11416V15.0137H10.886ZM3.62979 4.17148C5.40166 2.39961 7.5251 1.51367 10.0001 1.51367C12.4751 1.51367 14.5845 2.39961 16.3282 4.17148C18.1001 5.91523 18.986 8.02461 18.986 10.4996C18.986 12.9746 18.1001 15.098 16.3282 16.8699C14.5845 18.6137 12.4751 19.4855 10.0001 19.4855C7.5251 19.4855 5.40166 18.6137 3.62979 16.8699C1.88604 15.098 1.01416 12.9746 1.01416 10.4996C1.01416 8.02461 1.88604 5.91523 3.62979 4.17148Z" fill="#FF7A7A" />
  </svg>
);
